var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTeams = function SvgTeams(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57141 10.3886V16.7144C8.57141 17.4867 8.76084 18.2135 9.08998 18.8572H13.3748C13.9817 18.8572 14.5714 18.2461 14.5714 17.6966V9.44665L14.3306 9.42865H9.53141C9.00084 9.42865 8.57141 9.85808 8.57141 10.3886Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5714 6.85712H11.0206C11.3857 8.00397 12.4469 8.83969 13.7146 8.83969C14.0154 8.83969 14.2991 8.78055 14.5717 8.69397V7.8574C14.5717 7.30712 14.1217 6.85712 13.5714 6.85712Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3196 9.42859H17.0399L15.845 10.3946V15.1852C15.845 16.9637 17.2867 18.4054 19.0653 18.4054C20.8439 18.4054 22.2856 16.9637 22.2856 15.1852V10.3946C22.2856 9.86145 21.8527 9.42859 21.3196 9.42859Z",
    fill: "#5059C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 6.42856C21.4286 7.61228 20.4695 8.57142 19.2857 8.57142C18.102 8.57142 17.1429 7.61228 17.1429 6.42856C17.1429 5.24485 18.102 4.28571 19.2857 4.28571C20.4695 4.28571 21.4286 5.24485 21.4286 6.42856Z",
    fill: "#5059C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53141 9.42859H17.04C17.5706 9.42859 18 9.85802 18 10.3886V16.7143C18 19.3183 15.8897 21.4286 13.2857 21.4286C10.6817 21.4286 8.57141 19.3183 8.57141 16.7143V10.3886C8.57141 9.85802 9.00084 9.42859 9.53141 9.42859Z",
    fill: "#7B83EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5544 5.99999C16.5544 7.56856 15.2832 8.83971 13.7147 8.83971C12.1461 8.83971 10.8741 7.56856 10.8741 5.99999C10.8741 4.43142 12.1461 3.16028 13.7147 3.16028C15.2832 3.16028 16.5544 4.43142 16.5544 5.99999Z",
    fill: "#7B83EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0205 6.85712H13.5714C14.1217 6.85712 14.5717 7.30712 14.5717 7.8574V8.69397C14.2991 8.78054 14.0154 8.83969 13.7145 8.83969C12.4468 8.83969 11.3857 8.00397 11.0205 6.85712ZM8.57141 16.7143V10.3886C8.57141 9.85806 9.00084 9.42863 9.53141 9.42863H14.3306L14.5714 9.44663V17.6966C14.5714 18.2461 13.9817 18.8572 13.3748 18.8572H9.08998C8.76084 18.2135 8.57141 17.4866 8.57141 16.7143Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 18H2.71403C2.1646 18 1.7146 17.55 1.7146 16.9997V7.00029C1.7146 6.45 2.1646 6 2.71403 6H12.7143C13.2646 6 13.7146 6.45 13.7146 7.00029V16.9997C13.7146 17.55 13.2646 18 12.7143 18Z",
    fill: "#4B53BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4405 9.92368H8.39279V15.4282H7.04708V9.92368H4.98822V8.57111H10.4405V9.92368Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTeams);
export { ForwardRef as ReactComponent };